/* =========================================================================
 * /docs/EULA — End User License Agreement.
 *
 * Rewritten as part of the 2026 redesign — uses the shared LegalDoc layout
 * for consistency with the other legal pages.
 * ========================================================================= */

import { LegalDoc } from "pages/Docs/components/LegalDoc";

const SECTIONS = [
  {
    title: "License grant",
    body: (
      <p>
        Subject to the terms and conditions of this EULA, Company grants you a limited,
        non-exclusive, non-transferable, revocable license to use the App solely for your personal,
        non-commercial purposes.
      </p>
    ),
  },
  {
    title: "Restrictions",
    body: (
      <>
        <p>You may not:</p>
        <ul>
          <li>
            Modify, adapt, translate, reverse engineer, decompile, disassemble, or create derivative
            works based on the App;
          </li>
          <li>
            Copy, distribute, transfer, sublicense, lease, lend, or rent the App to any third party;
          </li>
          <li>
            Remove, alter, or obscure any copyright, trademark, or other proprietary notices
            contained in the App;
          </li>
          <li>Use the App in any manner that violates applicable laws or regulations.</li>
        </ul>
      </>
    ),
  },
  {
    title: "Intellectual property rights",
    body: (
      <p>
        The App and all intellectual property rights therein are and shall remain the exclusive
        property of Company and its licensors. Nothing in this EULA grants you any right or license
        to use any of Company&apos;s trademarks, logos, or other branding elements.
      </p>
    ),
  },
  {
    title: "Disclaimer of warranty",
    body: (
      <p>
        THE APP IS PROVIDED &ldquo;AS IS&rdquo; WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. TO
        THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, COMPANY DISCLAIMS ALL WARRANTIES, WHETHER
        EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE, INCLUDING BUT NOT LIMITED TO WARRANTIES OF
        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
      </p>
    ),
  },
  {
    title: "Limitation of liability",
    body: (
      <p>
        IN NO EVENT SHALL COMPANY BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR
        PUNITIVE DAMAGES ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF THE APP, INCLUDING BUT NOT
        LIMITED TO LOSS OF PROFITS, DATA, OR BUSINESS INTERRUPTION.
      </p>
    ),
  },
  {
    title: "Governing law",
    body: (
      <p>
        This EULA shall be governed by and construed in accordance with the laws of the United
        States, without regard to its conflict of law provisions.
      </p>
    ),
  },
  {
    title: "Termination",
    body: (
      <p>
        Company may terminate this EULA at any time without notice if you fail to comply with any
        term or condition herein. Upon termination, you must cease all use of the App and destroy
        all copies of the App in your possession or control.
      </p>
    ),
  },
  {
    title: "Entire agreement",
    body: (
      <p>
        This EULA constitutes the entire agreement between you and Company regarding your use of the
        App and supersedes all prior or contemporaneous understandings and agreements, whether
        written or oral.
      </p>
    ),
  },
];

export const EULA = () => (
  <LegalDoc
    eyebrow="Legal"
    title="End User License Agreement"
    lastUpdated="July 2024"
    lead={
      <>
        This EULA is a legal agreement between you (&ldquo;User&rdquo;) and{" "}
        <strong>Halyard LLC</strong> (&ldquo;Company&rdquo;) governing your use of the{" "}
        <strong>Bripplex</strong> mobile application (the &ldquo;App&rdquo;).
      </>
    }
    sections={SECTIONS}
    footnote={
      <>
        By downloading, installing, or using the App, you acknowledge that you have read,
        understood, and agree to be bound by this EULA.
      </>
    }
  />
);
